import api from '../axios.js'


export let loginUser=async(datos)=>{
		try{
			let validate=await api.post(`/usuario/validate`,datos);
			sessionStorage.setItem('AccessToken',validate.data.AccessToken);

			switch(validate.data.user.tipo){
				case 1:
					sessionStorage.setItem('id', validate.data.user.id);
					sessionStorage.setItem('name', validate.data.user.name);
					sessionStorage.setItem('usuario', validate.data.user.usuario);
					sessionStorage.setItem('tipo', validate.data.user.tipo);
					sessionStorage.setItem('login', true);
					break
				case 2:
					sessionStorage.setItem('id', validate.data.user.id);
					sessionStorage.setItem('name', validate.data.user.name);
					sessionStorage.setItem('usuario', validate.data.user.usuario);
					sessionStorage.setItem('tipo', validate.data.user.tipo);
					sessionStorage.setItem('login', true);
					break
				case 3:
					sessionStorage.setItem('id', validate.data.user.id);
					sessionStorage.setItem('name', validate.data.user.name);
					sessionStorage.setItem('usuario', validate.data.user.usuario);
					sessionStorage.setItem('tipo', validate.data.user.tipo);
					sessionStorage.setItem('login', true);
					break
				default:
					console.log("");
			};
			return validate.data.user
		}catch(err){throw new Error(err.response.data)}
	};

	export let logoutUser=async()=>{

		try{
 			await api.post(`/usuario/logout`);
 			sessionStorage.removeItem('AccessToken');
 			sessionStorage.removeItem('id');
 			sessionStorage.removeItem('name');
 			sessionStorage.removeItem('usuario');
 			sessionStorage.removeItem('tipo');
 			sessionStorage.removeItem('login');
 			return true
 		}catch(err){
 					sessionStorage.removeItem('AccessToken');
 					sessionStorage.removeItem('id');
 					sessionStorage.removeItem('name');
 					sessionStorage.removeItem('usuario');
 					sessionStorage.removeItem('tipo');
 					sessionStorage.removeItem('login');
 					throw new Error(err)
 		}
	}


